import { reciprocal_clubs, services_forms_icon } from '../../assets/base64';
import { IS_WEB } from '../../constants/platform';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { NavigationService } from '../../services/navigation';

export const CLUB_SERVICES_TABS = [
  {
    icon: IS_WEB
      ? addBase64Prefix(services_forms_icon)
      : require('../../assets/services-forms-icon.png'),
    title: 'Services & Forms',
    onPress: () => {
      NavigationService.push('ServiceForm');
    },
  },
  {
    icon: require('../../assets/feedback-icon.png'),
    title: 'Feedback',
    onPress: () => {
      NavigationService.push('Feedback');
    },
  },
  {
    icon: require('../../assets/survey.png'),
    title: 'Survey',
    onPress: () => {
      NavigationService.push('Survey');
    },
  },
  {
    icon: IS_WEB
      ? addBase64Prefix(reciprocal_clubs)
      : require('../../assets/reciprocal-clubs.png'),
    title: 'Reciprocal clubs',
    onPress: () => {
      NavigationService.push('ReciprocalClubs');
    },
  },
];
